// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dDdRK","content":"styles_content__23DLa","row":"styles_row__E3kW9","footer":"styles_footer__39qiF","phraseLength":"styles_phraseLength__2Hhh1"};